import { styled } from '@mui/system';
import Stack from '@mui/material/Stack';

export const CopyRightContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.custom.components.copyrightBlock.backgroundColor,
  color: theme.custom.components.copyrightBlock.color,
  marginBottom: 0,
  alignItems: 'center',
  fontSize: '12px',
}));


// a {
//   color: ${({ theme })=>theme.custom.components.copyrightBlock.color};
//   text-decoration: none;
// }
//
// a:hover {
//   text-decoration: underline;
// }
